import React from "react";
import Header from "../header";
import Footer from "../footer";
import UserRoute from "../ProtectedRoute/UserProtecTedRoute";

const Layout = ({ children }) => {
  return (
    <UserRoute>
      <header>
        <Header />
      </header>

      <main style={{ minHeight: "80vh" }}>{children}</main>

      <footer>
        <Footer />
      </footer>
    </UserRoute>
  );
};

export default Layout;
